/**
 * Created by slava on 4/3/20
 * Scene component extracted from Map2dLocationScene
 */

class Map2dLocationSceneComponent extends ScriptComponent {
    onCreate() {
        this.styles = PrefabBuilder.resolveProperty(this.options.styles, this.context);
    }

    onAttach() {
        this.styling = this.getBackgroundStyles();

        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.sceneComponent.setStyling(this.styling);
        this.sceneComponent.setAudioStyles(this.getAudioStyles(this.styling));
        this.sceneComponent.setBundles(this.listBundles());
        this.sceneComponent.options.preloadBundles = this.listPreloadBundles();
        this.sceneComponent.options.lazyBundles = this.lazyBundles();

        const preloadBundles = ["tile_shop"];

        if (cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
            preloadBundles.push("starter_pack");
        }

        ComponentMap.get(this.node, MainSceneComponent).preloadBundles = preloadBundles;
    }

    onDestruct() {
        if (cleverapps.gameLevel.withOwnLevel() || cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
            connector.platform.gameplayStop(cleverapps.gameLevel.getLevel());
        }

        this.extraBarTable && this.extraBarTable.destructor();

        if (Map2dLocation.currentLocation) {
            Map2dLocation.currentLocation.stop();
            Map2dLocation.currentLocation = undefined;
        }
    }

    onBeforeSceneLoaded() {
        this.game = new Map2dLocation();
    }

    onSceneLoaded() {
        this.createMap();

        this.game.onShowMergeBonus = this.node.createListener(this.showMergeBonus.bind(this));

        this.addTutorial();

        this.advice = new Map2dAdviceView(this.game.map.advice, this.node);

        if (this.styling.surfaceAnimation) {
            const surfaceAnimation = new cleverapps.Spine(this.styling.surfaceAnimation);
            surfaceAnimation.setAlignment({ align: "center" }, { align: "center" });
            surfaceAnimation.setAnimation(0, "animation", true);
            this.getCloudsAboveLayer().addChild(surfaceAnimation);
        }

        if (this.styling.topAnimation) {
            this.node.background.topAnimation = new cleverapps.Spine(this.styling.topAnimation);
            this.node.background.topAnimation.setAnimation(0, "animation", true);
            this.node.background.topAnimation._hideInSceneDebugger = true;
            this.getAnimationsLayer().addChild(this.node.background.topAnimation);
        }

        if (this.game.pixelsPlanner) {
            const pixelsPlannerView = new PixelsPlannerView(this.game.pixelsPlanner);
            this.getAnimationsLayer().addChild(pixelsPlannerView);
        }

        if (this.game.friendPixelsPlanner) {
            const friendPixelsPlannerView = new PixelsPlannerView(this.game.friendPixelsPlanner);
            this.getAnimationsLayer().addChild(friendPixelsPlannerView);
        }

        if (this.game.pocket) {
            this.game.pocket.onAddBubble = this.createPocketBubbleView.bind(this);
            this.game.pocket.bubbles.forEach(function (bubble) {
                this.createPocketBubbleView(bubble);
            }, this);
        }

        if (cleverapps.gameModes.axemerge) {
            // as after education stage
            const fogBlocks = this.game.map.fogs.blocks;
            if (fogBlocks.fog0) {
                fogBlocks.fog0.unlock();
            }
            if (fogBlocks.fog1) {
                fogBlocks.fog1.unlock();
            }
        }

        if (cleverapps.git) {
            cleverapps.git.changeFolders([GitManager.FOLDERS.UNIT_ANCHORS]);
        }

        const roomToneEffect = cleverapps.skins.getSlot("roomToneEffect");
        if (roomToneEffect) {
            this.node.runAction(new cc.RepeatForever(new cc.Sequence(
                new cc.DelayTime(5),
                cleverapps.effects.fireAction(roomToneEffect),
                new cc.DelayTime(5)
            )));
        }

        if (cleverapps.gameLevel.withOwnLevel() || cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
            connector.platform.gameplayStart(cleverapps.gameLevel.getLevel());
        }
    }

    onReady() {
        if (this.extraBarView) {
            this.extraBarControl = this.extraBarView.getParent();
        }

        this.onResize();
    }

    createMap() {
        this.innerMap = new Map2dInnerView(this.game.map);
        this.map = this.innerMap.wrapWithScroll(this.mapPositionChanged.bind(this));

        this.node.addChild(this.map);
        this.onResize();
        this.setInitialScroll(this.game.map.getFocusCell() || this.game.map.getMapCenterCell());
    }

    setInitialScroll(cell) {
        let scrollCell = this.innerMap.getCell(cell.x, cell.y);
        scrollCell = scrollCell ? this.map.normalizePoint(this.map.outOfBoundariesVector(scrollCell)) : this.map.getContainerPosition();

        this.map.scrollToPoint(scrollCell);
    }

    onPlayIntro(f, silent) {
        let actions = this.game.listIntroActions();

        if (silent) {
            actions = actions.map((action) => function (f) {
                action(f, silent);
            });
        }

        this.game.introPlaying = true;

        cleverapps.focusManager.compound(() => {
            this.game.introPlaying = false;
            f();
        }, actions);

        return true;
    }

    onResize() {
        if (this.map) {
            const bgSize = cleverapps.resolution.getBgSize();
            const safePadding = cleverapps.resolution.getSafePadding();
            this.map.setContentSize(bgSize.width, bgSize.height);
            this.map.setAlignment(bgSize.width / 2 - safePadding.left, bgSize.height / 2 - safePadding.bottom);

            this.map.zoomHandler.setZoom(this.map.zoom, true);
            this.map.updateVisibility();

            this.mapPositionChanged();
        }

        if (this.extraBarControl) {
            const availableWidth = cleverapps.resolution.getSceneSize().width * 0.7;
            this.extraBarControl.setScale(Math.min(1, availableWidth / this.extraBarControl.width));
        }
    }

    getAnimationsLayer() {
        return this.innerMap.animations;
    }

    getCloudsAboveLayer() {
        return this.innerMap.cloudsAbove;
    }

    hasExtraBar() {
        return !(cleverapps.gameModes.noSidebar || cleverapps.config.demoMode || typeof ExtraBarIconsDataSource === "undefined"
            || !cleverapps.environment.isMainScene() && !cleverapps.environment.isGameScene());
    }

    buildExtraBar() {
        const styles = this.styles.extraBar;

        this.extraBarTable = new ScrollTable(new ExtraBarIconsDataSource(), {
            direction: cleverapps.UI.HORIZONTAL,
            scrollDisabled: true
        });

        const extraBarView = this.extraBarView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: false,
            mouseScroll: false,
            touchScroll: true,
            dock: { toEnd: true }
        });

        this.extraBarTableHandler = new TableHandler(this.extraBarTable, extraBarView, {
            rowConstructor: ExtraBarIconView,
            animations: ExtraBarIconAnimations,
            scroll: cleverapps.UI.ScrollView.SCROLLS.LOWER_RIGHT,
            countOfRowsToSnap: 4,
            styles
        });

        return extraBarView;
    }

    hasOrangery() {
        return !!(Map2d.currentMap.orangery && !cleverapps.gameModes.noControls);
    }

    buildOrangery() {
        this.orangeryView = new OrangeryView(Map2d.currentMap.orangery);
        return this.orangeryView;
    }

    getOrangeryControlName() {
        return Map2d.currentMap.orangery.getControlName();
    }

    hasPlayButton() {
        return typeof PlayButtonView !== "undefined";
    }

    buildPlayButton() {
        this.playButton = new PlayButtonView({
            isSmall: true,
            hard: true
        });
        return this.playButton;
    }

    getBackgroundStyles() {
        return cleverapps.skins.getSlot("gameSceneBg") || cleverapps.styles.Map2dLocationScene.backgroundStyles;
    }

    createPocketBubbleView(bubble) {
        const pocketBubbleView = new PocketBubbleView(bubble, this.map.getVisibleRect());
        this.getAnimationsLayer().addChild(pocketBubbleView);
    }

    showMergeBonus(units) {
        const styles = this.styles.mergeBonus;

        const position = cc.getCenter(units.map(function (unit) {
            return this.game.map.getMapView().alignInGrid(unit.x, unit.y);
        }, this));

        const animation = new cleverapps.Spine(bundles.merge_animations.jsons.bonus_shining_json);
        animation.setAnchorPoint(0.5, 0.5);
        animation.setAlignment(position.x + styles.x, position.y + styles.y);
        animation.setAnimation(0, "animation", false);
        animation.setCompleteListenerRemove();
        this.getAnimationsLayer().addChild(animation);
    }

    makeNodeVisible(target, options) {
        options = options || {};

        const currentZoom = Map2dScroller.currentScroller.getScrollZoom();

        // SCROLL SPEED options.speed
        this.map.runAction(new cc.Sequence(
            new cc.ScrollAction(target, {
                skipFocusReport: true,
                duration: options.duration || 1,
                visibleBox: {
                    left: 0.74,
                    right: 0.74,
                    top: 1 / (currentZoom * 1.87),
                    bottom: 0.8
                }
            }),
            new cc.CallFunc(options.callback || (() => {}))
        ));
    }

    addTutorial() {
        if (typeof MergeTutorialView === "undefined") {
            return;
        }
        const mergeTutorialView = new MergeTutorialView(this.game.tutorial);
        mergeTutorialView.setAlignment(this.node.width / 2, this.node.height / 2);
        this.node.addChild(mergeTutorialView);
    }

    mapPositionChanged() {
        if (!this.map) {
            return;
        }

        const styles = this.styling;

        if (!styles.parallax || !this.node.background) {
            return;
        }

        const safePadding = cleverapps.resolution.getSafePadding();
        const bgSize = cleverapps.resolution.getBgSize();

        const scale = this.map.zoom - this.map.zoomHandler.minZoom;
        const normalizedScale = Math.max(1.1 * bgSize.height / this.node.background.height, 1.25 + Map2dLocationSceneComponent.PARALLAX_FACTOR * scale)
            + 0.001 * (safePadding.bottom + safePadding.top);
        this.node.background.setScale(normalizedScale);

        const scroll = this.map.getScrollPercent();
        const normalizedScroll = {
            x: 2 * (scroll.x - 0.5),
            y: 2 * (scroll.y - 0.5)
        };

        let x = this.node.width / 2 + Map2dLocationSceneComponent.PARALLAX_FACTOR * this.node.width * normalizedScroll.x * (1 + scale);
        let y = this.node.height / 2 + Map2dLocationSceneComponent.PARALLAX_FACTOR * this.node.height * normalizedScroll.y * (1 + scale);

        if (styles.parallax.hideHorizon) {
            x = this.node.width * (0.5 + 0.1 * normalizedScroll.x);
            y = this.node.height * (1.2 + 0.9 * normalizedScroll.y);
        }

        this.node.background.setAlignment(x - safePadding.left, y - safePadding.bottom / 2);

        if (styles.topAnimation && this.node.background.topAnimation) {
            this.node.background.topAnimation.setAlignment(this.map.getCurrentPosition().x + safePadding.left, this.map.getCurrentPosition().y + safePadding.bottom);
            this.node.background.topAnimation.setScale(Math.max(bgSize.height / this.node.background.topAnimation.height, 1.05 / this.map.zoom));
        }
    }

    listBundles() {
        const location = cleverapps.meta.getSelectedLocation();

        const result = [];

        result.push(location.locationConfig.locationBundleId);
        result.push(Map2d.getTilesTexture(location.meta.tiles));
        result.push(Map2d.getUnitsTexture(location.meta.units));
        result.push(Map2d.getCustomUnitsTexture());

        // main-world unit rewards keep drawing from this atlas after their window is gone (the flight home),
        // so outside main the scene holds it instead of the windows alone
        if (!location.locationConfig.isMain && bundles.main_world_reward_units) {
            result.push("main_world_reward_units");
        }

        const backgroundBundle = Map2d.getBackgroundBundles(location.locationConfig.locationId);
        if (bundles[backgroundBundle]) {
            result.push(backgroundBundle);
        }

        if (cleverapps.gameModes.axemerge) {
            result.push("axemerge");
        }

        if (cleverapps.miniPromo && cleverapps.miniPromo.isAvailable()) {
            result.push(MiniPromo.BUNDLE);
        }

        result.push("game"); // for background music only
        result.push(`quests_${location.meta.units}`);
        result.push(`quests_${location.locationId}`);
        result.push(`unitstories_${location.locationId}`);

        if (location.locationConfig.isMain && cleverapps.config.features.includes("island_decoration")) {
            const mission = IslandDecorationLogic.findRunningMission();
            const period = mission && mission.logic.period;
            if (period && bundles[`island_decoration_items_${period}`]) {
                result.push(`island_decoration_items_${period}`);
            } else {
                result.push("island_decoration_items_stub");
            }
        }

        return result;
    }

    listPreloadBundles() {
        const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
        const names = [];

        if (locationConfig.isMain || locationConfig.withOwnGameLevel) {
            names.push("levelupwindow");
        }

        if (locationConfig.isMain) {
            names.push("orders_portraits");
        }

        return names;
    }

    lazyBundles() {
        const location = cleverapps.meta.getSelectedLocation();

        let result = [
            "pixeloffer"
        ];

        if (bundles[`pixels_${location.meta.units}`]) {
            result.push(`pixels_${location.meta.units}`);
        } else {
            result.push("pixels_main");
        }

        result = result.concat(Families.listLazyBundles(Object.keys(location.families)));
        return result;
    }

    animateZoom(zoom, duration, f) {
        zoom = this.map.zoomHandler.normalizeZoom(zoom);

        this.map.runAction(new cc.Sequence(
            new cc.ZoomAction(duration, {
                zoom
            }),
            new cc.CallFunc(f)
        ));

        this.mapPositionChanged();
    }

    getAudioStyles(styling) {
        return {
            res: cleverapps.skins.getSlot("gameAudio") || styling.music,
            fadeIn: this.styles.sound.fadeIn,
            delay: this.styles.sound.delay
        };
    }
}

Map2dLocationSceneComponent.PARALLAX_FACTOR = 0.08;

Prefab.registerComponent("Map2dLocationSceneComponent", Map2dLocationSceneComponent);

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SCENE_ANIMATE_DELTA_TEXT: {
        size: 52,
        color: cleverapps.styles.FONTS.LIGHT_TEXT_COLOR
    },
    EXPEDITION_CUSTOMER_INGREDIENT_INFOVIEW: {
        size: 36,
        stroke: {
            size: 2,
            color: new cc.Color(44, 64, 90, 255)
        },
        shadow: {
            color: new cc.Color(67, 69, 74, 128),
            direction: cc.size(1, -4),
            blur: 0
        },
        color: cleverapps.styles.COLORS.WHITE
    }
});

// sound / extraBar / mergeBonus moved to res/prefabs/map2dlocationscene.prefab.json (params.styles).
// backgroundStyles stays here because it is read outside this scene (editor/editorlocationscene.js, editor/editorscene.js).
cleverapps.styles.Map2dLocationScene = {
    backgroundStyles: {
        music: bundles.game.urls.background_music_game
    }
};
